var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.otherCompanyConstruction)?_c('OtherCompanyConstructionEdit',_vm._g(_vm._b({attrs:{"constructionOptions":_vm.constructionOptions}},'OtherCompanyConstructionEdit',{
    otherCompanyConstruction: _vm.otherCompanyConstruction
  },false),{ ok: _vm.ok, cancel: _vm.cancel })):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }